import React from 'react';

interface StatTileProps {
  label: string;
  value: React.ReactNode;
  /** Small qualifier under the value (e.g. "of 378 checks"). */
  hint?: React.ReactNode;
  /** Optional chip rendered beside the value — pass a StatusChip. */
  chip?: React.ReactNode;
}

/**
 * A single headline number. Values use proportional figures (never
 * tabular-nums, which makes standalone numbers look loose at display sizes)
 * and stay in primary ink — colour is carried by the chip, not the digits.
 */
export function StatTile({ label, value, hint, chip }: StatTileProps) {
  return (
    <div className="rounded-[var(--radius-lg)] border border-[var(--card-border)] bg-[var(--card-bg)] p-3 sm:p-4">
      <div className="text-[0.75rem] font-medium uppercase tracking-[0.04em] text-[var(--text-dim)]">
        {label}
      </div>
      <div className="mt-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-1">
        <span className="text-[1.5rem] font-semibold leading-none tracking-[-0.02em] text-[var(--text-main)] sm:text-[1.75rem]">
          {value}
        </span>
        {chip}
      </div>
      {hint && <div className="mt-1 text-[0.75rem] text-[var(--text-dim)]">{hint}</div>}
    </div>
  );
}
